/* Barra de progresso do carrinho: frete grátis + níveis de brinde.
   Os marcos vêm de window.LofRewards (cart-rewards-core.js) e são recalculados
   a cada atualização: com um combo "compre X, ganhe Y" ativo, os níveis por
   valor saem da barra — o Shopify só aplica um desconto automático de produto
   por pedido, e prometer os dois seria prometer o que o checkout não entrega. */
(function () {
  'use strict';

  var R = window.LofRewards;
  if (!R || !R.temBeneficios || !document.querySelector('[data-cart-progress]')) return;

  var fmt = R.fmt;
  var esc = R.esc;

  function cartao(marco, atingido) {
    var capa = marco.itens.filter(function (i) { return i.imagem; })[0] || marco.itens[0];
    var visual = capa.imagem
      ? '<img src="' + esc(capa.imagem) + '" alt="" width="32" height="32" loading="lazy">'
      : '<span aria-hidden="true">' + capa.icone + '</span>';
    var nome = marco.itens.map(function (i) { return esc(i.rotulo); }).join(' + ');
    return '<li class="lof-prog__mark' + (atingido ? ' is-on' : '') + '">' +
             '<span class="lof-prog__ico">' + visual + '</span>' +
             '<span class="lof-prog__nome">' + nome + '</span>' +
             '<span class="lof-prog__val">' + fmt(marco.valor) + '</span>' +
           '</li>';
  }

  function indiceAtual(marcos, valor) {
    var i = 0;
    while (i < marcos.length && valor >= marcos[i].valor) i++;
    return i;
  }

  function mensagem(marcos, valor) {
    var n = marcos.length;
    var i = indiceAtual(marcos, valor);

    if (i >= n) {
      var ult = marcos[n - 1];
      if (ult.itens.length === 1 && ult.itens[0].variante) {
        return esc((R.textos.ok || '🎁 {produto} liberado!')
          .replace(/\{valor\}/g, '').replace(/\{produto\}/g, ult.itens[0].inline));
      }
      return '🎉 <strong>' + ult.itens.map(function (x) { return esc(x.rotulo); }).join(' + ') +
             '</strong> liberado!';
    }

    var alvo = marcos[i];
    var falta = alvo.valor - valor;

    if (alvo.itens.length === 1 && alvo.itens[0].variante) {
      return esc((R.textos.falta || 'Compre mais {valor} e ganhe {produto}!')
        .replace(/\{valor\}/g, fmt(falta)).replace(/\{produto\}/g, alvo.itens[0].inline));
    }
    return 'Compre mais <strong>' + fmt(falta) + '</strong> e ganhe ' +
           alvo.itens.map(function (x) { return esc(x.inline); }).join(' + ') + '!';
  }

  /* Cada marco ocupa um trecho igual da barra: o preenchimento anda por
     trechos, como no modelo de escadinha. */
  function preenchimento(marcos, valor) {
    var n = marcos.length;
    var i = indiceAtual(marcos, valor);
    if (i >= n) return 100;
    var anterior = i === 0 ? 0 : marcos[i - 1].valor;
    var trecho = (valor - anterior) / (marcos[i].valor - anterior);
    return Math.max(0, Math.min(100, (i + trecho) / n * 100));
  }

  var ultimo = '';

  function pintar(carrinho) {
    var marcos = R.marcosDe(carrinho);
    var valor = R.valorBase(carrinho);
    /* Sem marcos (só um combo em jogo, sem frete grátis configurado) a barra não
       tem o que mostrar: quem avisa do brinde é o cart-gift.js. */
    var vazio = !carrinho.items.length || !marcos.length;
    var pct = vazio ? 0 : preenchimento(marcos, valor);
    var texto = vazio ? '' : mensagem(marcos, valor);
    var marcas = marcos.map(function (m) { return cartao(m, !vazio && valor >= m.valor); }).join('');
    var assinatura = texto + '|' + pct + '|' + marcos.length;

    document.querySelectorAll('[data-cart-progress]').forEach(function (bloco) {
      var msg = bloco.querySelector('[data-progress-msg]');
      var fill = bloco.querySelector('[data-progress-fill]');
      var marks = bloco.querySelector('[data-progress-marks]');
      if (msg) msg.innerHTML = texto;
      if (fill) fill.style.width = pct + '%';
      if (marks && assinatura !== ultimo) marks.innerHTML = vazio ? '' : marcas;
      bloco.classList.add('is-ready');
    });
    ultimo = assinatura;
  }

  function atualizar() { R.carrinho().then(pintar).catch(function () {}); }

  var drawer = document.querySelector('[data-cart-drawer]');
  var subtotal = drawer && drawer.querySelector('[data-cart-subtotal]');
  if (window.MutationObserver && subtotal) {
    new MutationObserver(atualizar).observe(subtotal, { childList: true, characterData: true, subtree: true });
  }
  atualizar();
})();
